/* CEJ的单元重点单词页面 */
/*  Author: qichen */
/* create: 2019/01/18 */
<template>
<div class="flex-center flex-column mainbody">
  <!-- 通用介绍 -->
  <div class="header-panel">
    <div class="headertitle">{{Data.data_raw.u_name}}的专属单词本</div>
  </div>
  <div class="text-border-panel">
    <div class="maintext">
      <span class="flex-row-center orange-bold" v-html="Data.unit_info.unit_name"> </span>
      <p>亲爱的家长，每一个单词的积累需要在实际的生活中不断地<strong>场景复现</strong>，才能更好的进行<strong>习得单词的音形意</strong>，而其中单词的发音在启蒙时期尤其重要，因此我们精心准备了孩子在本单元的个性化单词本，以供孩子反复练习发音！家长也可以在家里跟孩子一起玩闪卡的游戏来帮助孩子更快更好的习得词汇！尽量不要翻译中文哟！</p>


    </div>
  </div>


  <div class="header-panel" v-if="Data.unit_info.course_info">
    <div class="headertitle"> 本单元薄弱词汇 </div>
  </div>


  <div class="text-border-panel" v-if="Data.unit_info.course_info">
    <div class="maintext">
        <p>{{Data.data_raw.u_name}}宝贝当前已经学习到<span class="orange-bold" v-html="Data.unit_info.unit_name"> </span>主题啦，课前预习我们注重单词的发音练习和对话理解，如果宝贝没有好好预习，课中单词的发音就不是很好呢！同时课中宝贝还会接触一些新的单词不会读，别担心！<strong >宝贝经常上课的<span class="orange-bold">{{Data.data_raw.tea_name}}</span> 外教老师细心指出孩子发音有问题的单词</strong>，点击单词即可到达单词页面学习呢！本单元的以下几节课老师有纠错：</p>

      <div class="resource-list" id="key_word">
        <div class="course-info"  v-for="lesson in Data.unit_info.course_info">
         <span class="orange-bold"> {{lesson.lesson_name}}</span></br>
          <div class="word-mean" v-for="word in lesson.words">
            <a :href="'/resource/word/' + word.id + tailUrl"><b> {{word.word_name}} </b></a>
              </br>
               <span v-for="part in word.meaning">
                <span>{{part.part}} </span>
                <span v-for="tmp in part.means" v-text="tmp+';'"></span>
                </span>
          </div>
        </div>
      </div>
    </div>
  </div>




  <div class="header-panel" v-if="Data.unit_info.word_set">
    <div class="headertitle"> 本单元核心词汇 </div>
  </div>


  <div class="text-border-panel" v-if="Data.unit_info.word_set">
    <div class="maintext">

        <p>配合咱们的课前预习单词的发音练习，为了帮助宝贝更好地课后复习单词，外教老师精心准备了<span class="orange-bold"  v-html="Data.unit_info.unit_name"></span>主题需要掌握的所有核心词汇，一起来看看：</p>
      <div class="resource-list" id="key_word">
        <div class="word-mean" v-for="word in Data.unit_info.word_set">
          <a :href="'/resource/word/' + word.id + tailUrl"><b> {{word.word_name}} </b></a>
            <div v-for="part in word.meaning">
              <span>{{part.part}} </span>
              <span v-for="tmp in part.means" v-text="tmp+';'"></span>
            </div>
        </div>
      </div>
    </div>
  </div>

</div>
</template>

<script>
  import BaseVue from '@/components/BaseVue'

  export default {
    name: 'WordUnitTemplate',
    extends: BaseVue,
    data() {
      return {
        Data: {
          data_raw:{
            u_name:'学员',
            tea_name:'Miss'
          },
          unit_info:{}
      }
    }
  },
    computed: {
      tailUrl: function() {
        return this.url_params === '' ? '' : '?' + this.url_params
      }
    },
    created: function() {
      // let data_id = this.$route.params.id
      let data_id = this.$route.query.uid
      //在BaseVue里面增加配置 APPOINT_API: 'http://101.200.43.74:8181/app_opt/',
      let url = this.APPOINT_API + 'get_review?uid=' + data_id

      this.url_params = this.$route.fullPath.split('?')[1]
      let that = this;
      // 因为我这接口正常代码是10000和其他的0不一样，所以单独写个获取函数
      $.ajax({
        type: "GET",
        url: url,
        timeout: this.TIMEOUT,
        success: function (data) {
          if (typeof(data) === 'string') data = JSON.parse(data)
          if (data.error_code == 10000) {
            that.Data = data.ret.data
          }else{
            console.log('Error: ' + data)
          }
        }
      })
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/resource/WordUnit.vue